
import React from 'react';
import ExportLogButton from './ExportLogButton';
import BuildVersion from './BuildVersion';

const Footer = () => {
  const linkClass = "hover:text-white transition-colors min-h-[44px] sm:min-h-0 flex items-center px-2";

  return (
    <footer className="relative z-30 bg-black/20 backdrop-blur-md border-t border-white/10 mt-auto">
      <div className="container mx-auto px-4 sm:px-6 sm:pr-20 md:pr-24 py-3 sm:py-4 pb-safe flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-2">
        <p className="text-white/80 text-xs sm:text-sm font-light tracking-wide">
          Powered by <span className="font-semibold text-white">LED Logic</span>
        </p>
        <div className="flex flex-wrap justify-center sm:flex-row items-center gap-x-3 gap-y-0 sm:gap-4 text-xs sm:text-sm text-white/80">
          <a href="/help" className={linkClass}>Help</a>
          <a href="/troubleshooting" className={linkClass}>Troubleshoot</a>
          <a href="/support" className={linkClass}>Support</a>
          <a href="/privacy" className={linkClass}>Privacy</a>
          <a href="/terms" className={linkClass}>Terms</a>
          <a href="/accessibility" className={linkClass}>Accessibility</a>
          <a href="/attribution" className={linkClass}>Attribution</a>
          <a href="/reference" className={linkClass}>Technical Reference</a>
          <span className="hidden sm:inline-block h-3 w-px bg-white/20" aria-hidden="true" />
          <ExportLogButton />
          <span className="hidden sm:inline-block h-3 w-px bg-white/20" aria-hidden="true" />
          <BuildVersion />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
